import '../account/account_form_controller';
import { canPaginate } from '../../mixins/can_paginate';
import { NEW_ADMIN_URL } from 'environment';

angular
.module('app.views')
.config(($routeProvider) => {
    $routeProvider.when('/accounts', {
        template: require('./accounts.html'),
        controller: 'AccountsController'
    });
})
.controller('AccountsController', function($scope, $location, $modal, Account, Config) {
    $scope.config = Config;
    $scope.newAdminURL = NEW_ADMIN_URL;
    $scope.loading = true;

    canPaginate($scope, $location);
    $scope.s || ($scope.s = 'name');

    $scope.accounts = Account.query(_.pick($scope, 'q', 's', 'p'), function(data, getResponseHeader) {
        $scope.loading = false;
        const pagination = getResponseHeader('X-Pagination');
        return $scope.pagination = (pagination ? JSON.parse(pagination) : {});
    });

    $scope.create = () =>
        $modal.open({
            template: require('../account/account_create_new_form.html'),
            controller: 'AccountFormController',
            size: 'lg',
            backdrop: 'static',
            resolve: {
              mode: () => 'standard'
            }
        }).result.then(a => $scope.show(a));

    $scope.extraFields = localStorage.getItem('accounts.fields');
    if ($scope.extraFields) {
        $scope.extraFields = JSON.parse($scope.extraFields);
    } else {
        $scope.extraFields = {
            market: true,
            contract: false,
            payment_status: false,
            physical_status: false,
            created: true,
            expires: true,
            support_plan: false,
        };
    }

    // Count the number of columns visible
    let baseCount = 2;
    $scope.fieldCount = baseCount + Object.keys($scope.extraFields).filter((key) => $scope.extraFields[key] === true).length;

    $scope.toggle = function(field, e) {
        $scope.extraFields[field] = !$scope.extraFields[field];
        localStorage.setItem('accounts.fields', JSON.stringify($scope.extraFields));
        $scope.fieldCount = baseCount + Object.keys($scope.extraFields).filter((key) => $scope.extraFields[key] === true).length;
        e.preventDefault();
        e.stopPropagation();
        return false;
    };
});


// WEBPACK FOOTER //
// ./views/accounts/accounts_controller.js